/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 12:36 PM
 *
 */

import PatientMedicalHistoryModal from 'features/members/components/modal/PatientMedicalHistoryAddEditModal/PatientMedicalHistoryAddEditModal';

export default PatientMedicalHistoryModal;
